export default __webpack_public_path__ + "static/media/soccer-bg.24a4dfc4.jpg";